<template>
    <el-select :value="value" class="select" clearable filterable :placeholder="$t('shared.pleaseSelectProduct')" :loading="loading" @change="$emit('input', $event)">
        <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    import api from './api'
    export default {
        name: 'repair-code-selector',
        props: {
            value: {},
            productId: {
                type: Number,
                default: undefined
            },
            categoryId: {
                type: Number,
                default: undefined
            }
        },
        data() {
            return {
                loading: false,
                categories: []
            }
        },
        watch: {
            productId: function (val) {
                if (!val) {
                    this.categories = []
                } else {
                    this.loading = true
                    api.getCodes(val, this.categoryId).then(response => {
                        this.loading = false
                        this.categories = response.data
                    })
                }
            },
            categoryId: function (val) {
                if (!val) {
                    this.categories = []
                } else {
                    this.loading = true
                    api.getCodes(this.productId, val).then(response => {
                        this.loading = false
                        this.categories = response.data
                    })
                }
            }
        }
    }
</script>

<style scoped>
    .select {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/repaircodeselector/RepairCodeSelector.vue